export default {
  sections: {
    settings: 'Ustawienia',
  },
  status_switch: {
    label: 'Program lojalnościowy',
    on: 'Wł.',
    off: 'Wył.',
    description: 'Klienci otrzymują cashback za każde zamówienie i mogą go wykorzystać przy płatności.',
    description_missing: 'Zapisz poniższe ustawienia, aby uruchomić program lojalnościowy.',
  },
  alerts: {
    off: 'Twój program lojalnościowy jest wyłączony. Klienci nie otrzymują cashbacku za nowe zamówienia, nie mogą wykorzystać swoich punktów i nie widzą programu w Twoim sklepie. Zebrane już punkty są zachowane i wygasają jak zwykle.',
    expired: 'Twój program lojalnościowy zakończył się. Włącz go, aby wznowić bez daty końcowej.',
  },
  form: {
    title: {
      label: 'Tytuł',
    },
    percentage: {
      label: 'Procent cashbacku',
      validation: {
        required: 'Procent cashbacku jest wymagany',
        min: 'Minimalna wartość procentu cashbacku wynosi {{value}}%',
        max: 'Maksymalna wartość procentu cashbacku wynosi {{value}}%',
      },
    },
    point_lifetime: {
      label: 'Przez ile dni klienci mogą wykorzystać punkty?',
      validation: {
        min: 'Minimalna liczba dni wygaśnięcia punktów: {{value}}',
      },
    },
    min_spending_limit: {
      label: 'Minimalny limit wydatków dla cashbacku',
      validation: {
        required: 'Minimalny limit wydatków jest wymagany',
        gt_zero: 'Minimalny limit wydatków musi być większy niż 0',
        lt_max_spending_limit: 'Minimalny limit wydatków musi być niższy niż maksymalny limit wydatków',
      },
    },
    max_spending_limit: {
      label: 'Maksymalny limit wydatków dla cashbacku',
      validation: {
        required: 'Maksymalny limit wydatków jest wymagany',
        gt_min_spending_limit: 'Maksymalny limit wydatków musi być wyższy niż minimalny limit wydatków',
      },
    },
    has_welcome_bonus: {
      label: 'Bonus powitalny',
      description: 'Przyznaj nowym klientom bonus cashback przy rejestracji',
    },
    welcome_bonus: {
      label: 'Wartość bonusu powitalnego',
    },
    has_end_date: {
      label: 'Czas trwania',
      options: {
        false: 'Bezterminowy',
        true: 'Z określoną datą końcową',
      },
    },
    end_date: {
      label: 'Data końcowa',
    },
    has_mobile_app_signup_bonus: {
      label: 'Bonus za rejestrację w aplikacji mobilnej',
      description: 'Nagradzaj użytkowników logujących się przez aplikację mobilną po raz pierwszy',
    },
    mobile_app_signup_bonus: {
      label: 'Kwota bonusu',
    },
  },
  tags: {
    inactive: 'Nieaktywny',
    active: 'Aktywny',
    expired: 'Wygasły',
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    changes_got_saved: 'Zmiany zostały zapisane',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    turned_on: 'Program lojalnościowy włączony',
    turned_off: 'Program lojalnościowy wyłączony',
  },
};
